<template>
  <div class="container">
    <transition name="fade" appear>
      <div class="modal-mask modal-backdrop">
        <div class="animate__fadeInDown animate__animated">
          <div class="modal-wrapper modal-inner">
            <div class="modal-dialogs" role="document">
              <div class="modal-content modal-lg">
                <a
                  href="JavaScript:void(0)"
                  class="btn-cross text-right close-modal"
                  @click="hideModal($event)"
                  >&times;</a
                >
                <div class="modal-body body_main">
                  <p v-if="error">{{ error }}</p>
                  <div class="row">
                    <div class="main_inventory">
                      <div class="top-label">
                        <div class="inventory-label">
                          <img
                            src="/images/inventory-label.png"
                            class="img-fluid"
                            alt=""
                          />
                          <h3 :class="mode">{{ modalName }}</h3>
                        </div>
                      </div>

                      <div class="top_btns">
                        <a
                          href="#"
                          class="inventory_btn mr-lg-4 mr-md-4"
                          @click.prevent="init('characters')"
                        >
                          <img
                            src="/images/character-img.png"
                            class="img-fluid"
                            alt=""
                          />
                          <h4>Character</h4>
                        </a>

                        <a
                          href="#"
                          class="inventory_btn"
                          @click.prevent="init('guns')"
                        >
                          <img
                            src="/images/guns-img.png"
                            alt=""
                            class="img-fluid"
                          />
                          <h4>Guns</h4>
                        </a>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 right_border">
                          <img
                            src="/images/loader-sm.gif"
                            class="loader-con"
                            alt="loading"
                            v-if="isLoading"
                          />
                          <div class="inventory-card scrollbar game-page">
                            <Myinventory :mode="mode" v-on:reload="init(schema,true)" />
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div
                            class="right-side_content mobile_marginLess scrollbar"
                          >
                            <div
                              :class="
                                modalName == 'Bank Robbery'
                                  ? 'd-flex justify-content-center multiple_cards'
                                  : ''
                              "
                            >
                              <div class="lg-card position-relative">
                                <div class="img-card main_cardframe user-gun">
                                  <a href="#" @click.prevent="init('guns')">
                                    <VideoBlock
                                      v-if="selectedGun"
                                      :link="selectedGun.templ_id"
                                    />
                                  </a>
                                </div>
                              </div>
                              <div
                                class="lg-card position-relative"
                                v-if="modalName == 'Bank Robbery'"
                              >
                                <div class="img-card main_cardframe dyn-card">
                                  <a href="#" v-if="totalDynamites > 0">
                                    <VideoBlock :link="609612" />
                                  </a>
                                  <a href="#" v-else>No Dynamite</a>
                                </div>
                              </div>
                            </div>
                            <div
                              class="row justify-content-center char-card-wrapper user-chars"
                            >
                              <div class="char-card-img">
                                <div class="img-frame">
                                  <VideoBlock
                                    v-if="selectedChars[0]"
                                    :link="selectedChars[0].templ_id"
                                  />
                                </div>
                              </div>
                              <div class="char-card-img">
                                <div class="img-frame">
                                  <VideoBlock
                                    v-if="selectedChars[1]"
                                    :link="selectedChars[1].templ_id"
                                  />
                                </div>
                              </div>
                              <div class="char-card-img">
                                <div class="img-frame">
                                  <VideoBlock
                                    v-if="selectedChars[2]"
                                    :link="selectedChars[2].templ_id"
                                  />
                                </div>
                              </div>
                              <small
                                v-if="mode == 'bankrobbery'"
                                class="text-warning"
                                >You may lost gun(15%) or energy(16%)</small
                              >
                              <small
                                v-if="mode == 'bankrobbery'"
                                class="text-default"
                                >You may get Gun(5%) or tokens(22%)</small
                              >
                              <small
                                v-if="mode == 'advanture'"
                                class="text-default"
                                >11% Chance you get game item</small
                              >
                              <small
                                v-if="mode == 'sherifraid'"
                                class="text-default"
                                >20% Chance you get gun blue print</small
                              >
                            </div>
                          </div>
                          <div class="bottom_btn text-center">
                            <a
                              href="#"
                              class="stake_btn"
                              @click.prevent="start()"
                            >
                              <img
                                src="/images/polygon-button-2.png"
                                class="img-fluid"
                                alt=""
                              />
                              <h5>Start</h5>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="showResult">
                        <h6 class="text-default">Reward</h6>
                        <Result
                          :result="result"
                          :reward="gameModes[mode].reward"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import ApiService from "../../services";
import "vue-loading-overlay/dist/vue-loading.css";
import VideoBlock from "../VideoBlock.vue";
import Myinventory from "../Myinventory.vue";
import { mapGetters } from "vuex";
import Result from "@/components/Result";
export default {
  props: ["error", "isShow", "mode"],
  name: "StakingModal",
  components: {
    VideoBlock,
    Myinventory,
    Result,
  },
  computed: {
    ...mapGetters([
      "selectedGun",
      "selectedChars",
      "selectedCharsIds",
      "totalDynamites",
      "resources",
    ]),
  },
  showModal: true,
  data() {
    return {
      gameModes: {
        bankrobbery: { locked: false },
        advanture: { locked: false },
        stagecoach: { locked: false },
        sherifraid: { locked: false },
      },
      isLoading: false,
      showResult: false,
      isImageLoaded: false,
      schema: "characters",
      selectedWeapon: "",
      gameItems: "",
      modalName: "Adventure",
      result: [""],
    };
  },
  mounted() {
    this.init(this.schema, true);
    this.gameItems = ApiService.gameItemList();
    if (this.mode == "bankrobbery") {
      this.modalName = "Bank Robbery";
    } else if (this.mode == "sherifraid") {
      this.modalName = "Sheriff's office Raid";
    } else if (this.mode == "stagecoach") {
      this.modalName = "Stage Coach";
    }
  },
  methods: {
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
      this.$store.commit("clearSelectedCards", []);
    },
    loaded() {
      this.isImageLoaded = true;
    },
    init(schema, refresh = false) {
      if (this.inventory && !refresh) {
        this.myInventory = this.myInventory.filter(
          (i) => i.value.schema == schema
        );
        this.myInventory.map(
          async (item) => !ApiService.isExpired(item.value.lock_end)
        );
      } else {
        this.isLoading = true;
        ApiService.getInventory((res) => {
          this.myInventory = res.filter((i) => i.value.schema == schema);
          this.myInventory.map(
            async (item) => !ApiService.isExpired(item.value.lock_end)
          );
          this.$store.commit("addInventory", this.myInventory);
          this.isLoading = false;
        });
      }
      this.schema = schema;
    },
    async start() {
      if (this.totalDynamites == 0 && this.mode == "bankrobbery") {
        ApiService.errorMsg("A dynamite is required to play bank robbery");
        return;
      }
      if (this.selectedChars.length == 0) {
        ApiService.errorMsg("Please select characters.");
        return;
      }
      if (!this.selectedGun) {
        ApiService.errorMsg("Please select gun.");
        return;
      }
      this.isLoading = true;
      const data = {
        contract: process.env.VUE_APP_CONTRACT,
        action: "game.start",
        data: {
          account: localStorage.getItem("wax_user"),
          mode: this.mode,
          gun: this.selectedGun.asset_id,
          characters: this.selectedCharsIds,
          dynamite:
            this.resources.length && this.mode == "bankrobbery"
              ? this.resources[0].key
              : 0,
        },
      };
      await ApiService.transaction(
        data,
        (res) => {
          if (res.processed) {
            ApiService.successMsg();
            ApiService.getCurrentGames((res) => {
              res.details.map(async (item) => {
                let row = item.value;
                row.locked = ApiService.isExpired(row.end_at);
                this.gameModes[item.key] = row;
              });
              this.$store.commit("addStake", this.gameModes);
              this.result = this.gameModes[this.mode].result.split(":");
              ApiService.getHeaderContents();
              this.showResult = true;
              this.isLoading = false;
            });
          }
        },
        (error) => {
          ApiService.errorMsg(error);
          this.isLoading = false;
        }
      );
    },
  },
};
</script>
  <style scoped>
.modal-wrapper .modal-dialogs .modal-content .close-modal {
  top: 0px;
  z-index: 2;
}
.char-card-img video {
  padding: 5px;
}
.lg-card video {
  padding: 2px;
}
.md-card video {
  padding: 2px;
}
.modal-inner {
  margin-top: 0;
  padding-top: 95px;
}
.right_border:before {
  content: "";
  background-image: url("/images/stick.png");
  width: 34px;
  height: 100%;
  position: absolute;
  right: -15px;
  background-position: 100% 100%;
  background-size: contain;
  top: 4px;
}
.stick img {
  height: 100%;
}
.main_inventory {
  width: 100%;
  background: url("/images/inventory-layer.png") no-repeat center;
  background-size: 100% 100%;
  margin-top: 0;
  height: 100%;
  /* padding-bottom: 30px; */
}
.modal-wrapper .modal-dialogs .modal-content {
  height: auto;
  width: 100%;
  background-color: transparent;
  border: none !important;
  padding: 0;
}
.modal-wrapper .modal-dialogs .modal-content .modal-body {
  padding: 0;
}
.top_btns {
  z-index: 1;
}

.left-side_content .col-4 {
  padding-right: 0px;
}

.buttons-wrapper {
  width: 70px;
  margin: auto;
}

.craft-card .wood-card-frame {
  width: inherit !important;
  padding: 0;
}
.left-side-wrapper {
  width: 42%;
}

.img-card {
  margin: 6px auto 0 auto;
  padding: 10px;
}
.img-card img {
  aspect-ratio: 3/2;
}
.img-card h6 {
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.left-side_content .col-4 {
  padding-right: 0px;
}
.dyn-card {
  width: 143px !important;
}
.right-side-wrapper {
  width: 42%;
  /* position: absolute;
  top: 16px;
  right: 39px; */
}

.crafting-tool-wrapper {
  padding: 4px 50px;
  height: 180px;
  overflow-y: scroll;
}
.crafting-tool_group {
  margin-top: 5px;
}

.crafting-tool_group span {
  display: inline-block;
  color: #fff;
}
.crafting-tool_group .crafting-img {
  width: 80px;
  margin: auto;
}
.crafting-tool_group .crafting-img img {
  aspect-ratio: 3/2;
  object-fit: contain;
}
.inventory-card,
.right-side_content {
  /* background: red; */
  /* overflow: auto; */
  /* padding: 0 20px 0 5px; */
  height: 385px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 45px;
  padding: 0 20px;
}
.right-side-wrapper .right-side_content .wood-card-frame {
  height: 180px;
  width: 150px;
}
.right-side_content .img-frame img {
  max-height: 100px;
  padding: 6px 4px;
  border-radius: 0 !important;
}

.bottom_btn {
  top: 0px;
  position: relative;
  text-align: right;
}
.sherifraid {
  padding: 0 13px;
  top: 14px !important;
}
.main_cardframe {
  background: url("/images/card-frame.png") no-repeat center;
  background-size: 100% 100%;
  height: 174px;
  width: 110px;
  margin: auto;
  padding: 10px;
  cursor: pointer;
}
.right-side_content .char-card-img .img-frame {
  height: 176px !important;
  width: 104px !important;
}
@media (max-width: 992px) {
  .modal-inner {
    margin-top: 80px;
  }
  .right_border:before {
    display: none;
  }
}
@media (max-width: 768px) {
  .left-side-wrapper,
  .right-side-wrapper {
    width: 100%;
  }
  .mobile_right_main {
    height: 330px;
    margin-top: 120px;
    /* overflow: scroll; */
  }
  .modal-inner {
    padding-top: 0px;
  }
  .wood-card-frame {
    background: url("/images/card-frame.png") no-repeat center;
    height: 300px;
    background-size: contain;
  }
  .mobile_marginLess {
    margin-top: 0px;
    overflow: hidden;
    height: 475px;
    padding-top: 45px;
  }
  .main_inventory {
    height: 700px;
    overflow-x: hidden;
    overflow-y: auto;
    margin-top: 130px;
    background: none;
  }
  .inventory-card {
    margin-top: 0px;
    padding: 0 10px 0 30px;
  }
  .left-side_content {
    margin-top: 0px;
    height: 500px;
  }
}
</style>